import React from 'react';
import { Link } from 'react-router-dom';
import { drapcodeIcon, drapcodeImgIcon } from '../../common/custom/icon-library';
import EnvironmentSelect from '../../common/formElements/EnvironmentSelect';

const ParentContentCard = ({
  children,
  title,
  icon,
  datasourceIconSvg,
  datasourceIconPng,
  pluginIconSvg,
  pluginIconPng,
  headerLink,
  headerTitle,
  headerText,
  bgColor,
  isSearch,
  updateSearchTerm,
  handleSearch,
  btnSize = 'sm',
  isEnvironment,
  refreshMethod,
  handleCancel,
  headerButton,
  CtaComponent,
  fullscreen,
}) => {
  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <div
        className="card"
        style={
          fullscreen ? { position: 'relative', top: '-119px', left: '-15px', width: '95vw' } : {}
        }
      >
        <div
          className="card-header card-header-icon"
          data-background-color={`${bgColor ? bgColor : 'drapcode-dark-blue'}`}
        >
          {icon && <i className={`wb ${drapcodeIcon(icon)}`}></i>}
          {datasourceIconSvg && (
            <span className="circle" style={{ fontSize: '23px', lineHeight: '33px' }}>
              <img
                src={drapcodeImgIcon(datasourceIconSvg, 'dataSource', 'svg')}
                width="23"
                height="23"
                className="no-wh"
                alt={datasourceIconSvg}
              />
            </span>
          )}
          {datasourceIconPng && (
            <span className="circle" style={{ fontSize: '23px', lineHeight: '33px' }}>
              <img
                src={drapcodeImgIcon(datasourceIconPng, 'dataSource', 'png')}
                width="23"
                height="23"
                className="no-wh"
                alt={datasourceIconPng}
              />
            </span>
          )}
          {pluginIconSvg && (
            <span className="circle" style={{ fontSize: '23px', lineHeight: '33px' }}>
              <img
                src={drapcodeImgIcon(pluginIconSvg, 'plugin', 'svg')}
                width="23"
                height="23"
                className="no-wh"
                alt={pluginIconSvg}
              />
            </span>
          )}
          {pluginIconPng && (
            <span className="circle" style={{ fontSize: '23px', lineHeight: '33px' }}>
              <img
                src={drapcodeImgIcon(pluginIconPng, 'plugin', 'png')}
                width="23"
                height="23"
                className="no-wh"
                alt={pluginIconPng}
              />
            </span>
          )}
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title" style={{ textTransform: 'revert' }}>
              {title}
            </h4>
            <div className="card-cta">
              {CtaComponent
                ? CtaComponent
                : headerLink && (
                    <Link
                      to={headerLink}
                      className="btn btn-theme-submit btn-md"
                      title={headerTitle}
                    >
                      <i className="wb webconnect-plus" /> {headerText}
                    </Link>
                  )}{' '}
            </div>
            {headerButton && (
              <div className="card-cta">
                {headerButton && (
                  <button
                    onClick={headerButton}
                    className="btn btn-theme-submit btn-md"
                    title={headerTitle}
                  >
                    <i className="wb webconnect-pencil" /> {headerText}
                  </button>
                )}
              </div>
            )}
          </div>
          <div className={`${isEnvironment ? 'row' : ''}`}>
            <div className={`${isEnvironment ? 'col-md-8' : ''}`}>
              {isSearch && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSearch();
                  }}
                  className={`${
                    isEnvironment ? '' : 'form-inline'
                  } mb-2 d-flex justify-content-between`}
                >
                  <input
                    type="text"
                    placeholder="Search..."
                    className="form-control col-11"
                    onChange={(e) => {
                      updateSearchTerm(e.target.value);
                    }}
                  />
                  <button
                    type="submit"
                    title={`Search ${title}`}
                    className={`btn btn-primary ${
                      btnSize === 'md' ? 'btn-md' : btnSize === 'lg' ? 'btn-lg' : 'btn-sm'
                    }`}
                  >
                    <i className="wb webconnect-search"></i>
                  </button>
                </form>
              )}
            </div>
            {isEnvironment && (
              <div className="col-md-4">
                <EnvironmentSelect
                  actions={actions}
                  projectId={projectId}
                  version={version}
                  refreshMethod={() => {
                    if (refreshMethod) {
                      refreshMethod();
                    }
                  }}
                />
              </div>
            )}
          </div>
          {children}
        </div>
        {handleCancel && (
          <div className="card-footer flex-start mt-4 pt-4">
            {' '}
            <button onClick={handleCancel} className="btn btn-outline btn-md float-right ">
              <i className="wb webconnect-times"> </i> Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentContentCard;
